import React from "react";
import ReactDOM from "react-dom";
import "../DeleteDialog/deleteDialog.scss";
import { useTranslation } from "react-i18next";
import { MODAL_ID } from "constants/settings";

export default function DiscardChangesDialog({ onConfirm, onCancel }) {
    const { t } = useTranslation();

    const handleConfirm = () => {
        onConfirm();
    };

    return ReactDOM.createPortal(
        <div className="overlay">
            <div className="overlay__wrapper">
                <div className="popup">
                    <div className="confirm__wrapper">
                        <ul className="confirm__list">
                            <li className="confirm__item">
                                <h2 className="confirm__title title--yellow">
                                    {t("discardChanges.title")}
                                </h2>
                            </li>
                            <li className="confirm__item">
                                <p className="confirm__option">
                                    {t("discardChanges.message")}
                                </p>
                            </li>
                            <li className="confirm__item">
                                <button
                                    className="popup__button"
                                    type="button"
                                    onClick={onCancel}
                                >
                                    {t("discardChanges.stay")}
                                </button>
                                <button
                                    className="popup__button popup__button--cancel"
                                    type="button"
                                    onClick={handleConfirm}
                                >
                                    {t("discardChanges.discard")}
                                </button>
                            </li>
                        </ul>
                        <button
                            className="popup__close-button payment-confirm__close-button"
                            type="button"
                            onClick={onCancel}
                        />
                    </div>
                </div>
            </div>
        </div>,
        document.getElementById(MODAL_ID)
    );
}